import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientAdminComponent } from './client-admin.component';
import { SharedModule } from 'src/app/modules/shared.module';
import { ClientAdminRoutingModule } from './client-admin-routing.module';
import { ZoneModule } from '../zone/zone.module';
import { UsersComponent } from './users/users.component';
import { SettingsComponent } from './settings/settings.component';
import { ProfileComponent } from './profile/profile.component';
import { SettingsModule } from './../settings/settings.module';


@NgModule({
  declarations: [ClientAdminComponent,
    UsersComponent,
    SettingsComponent,
    ProfileComponent],
  imports: [
    CommonModule,
    SharedModule,
    ClientAdminRoutingModule,
    ZoneModule,
    SettingsModule
  ]
})
export class ClientAdminModule { }
